import { ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { useToast } from "./ToastProvider";
import { useAuthContext } from "../../hooks/useAuthContext";

export const QueryProvider = ({ children }: { children: ReactNode }) => {
  const { showToast } = useToast();
  const { handleError } = useAuthContext();

  const queryClient = new QueryClient({
    defaultOptions: {
      mutations: {
        onError: (error: any) => {
          showToast(
            "error",
            error?.response?.data?.message || "Something went wrong"
          );
        },
      },
      queries: {
        retry: false,
        onError: handleError,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
